const initialState={
  rating:0,
  totalrating:0,
  numberofratings:0
}
const reducer = (state=initialState,action)=>{
  if(action.type==='UPDATERATING'){
    return {
              ...state,
              rating:action.payload,
              totalrating:state.totalrating+action.payload,
              numberofratings:state.numberofratings+1
          }
  }
  return state
}

export default reducer;